import { z } from "zod";
import { HousekeepingResponse } from "./IndexHousekeepingResponse";
import { BaseResponseSchema } from "../../base/response/BaseResponseSchema";

const Schema = HousekeepingResponse;

export const UpdateRoomConditionResponseSchema = BaseResponseSchema(Schema);
export type UpdateRoomConditionResponseType = z.infer<typeof Schema>;
export type UpdateRoomConditionResponseSchemaType = z.infer<typeof UpdateRoomConditionResponseSchema>;
